import { render, staticRenderFns } from "./RoleMod.vue?vue&type=template&id=38618d8c&scoped=true"
import script from "./RoleMod.vue?vue&type=script&lang=js"
export * from "./RoleMod.vue?vue&type=script&lang=js"
import style0 from "./RoleMod.vue?vue&type=style&index=0&id=38618d8c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38618d8c",
  null
  
)

export default component.exports